export default __webpack_public_path__ + "static/const-one-f0988327754731d5f7c049f68bad048b.png";